<template>
    <div class="login-dialog--login__content-container">
      <div class="login-dialog--login__content-container--text">
  
        <div class="login-dialog--login__content-container--text__input">
          <div class="d-flex justify-center mb-10">
            <v-progress-circular class="login-dialog__content-container--loader" v-if="true" color="var(--v-primary-base)"
              indeterminate size="82"></v-progress-circular>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "the-load-step",
    
    data() {
      return {
      }
    }
  };
  </script>
  
  <style scoped>
  .error--text {
    padding-bottom: 10px;
  }
  
  .portal-theme.theme--light.v-text-field:not(.v-input--has-state) {
    color: #579fa7 !important;
  }
  </style>
  